import React from "react";
import { Container } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import { useMobile } from "../hooks/isMobile.tsx";

const Privacy = () => {
    const { isMobile } = useMobile();
    return (
        <>
            <Seo
                title="Privacy Policy | FinQ India"
                description="How FinQ India (Konsri Technologies Private Limited) collects, uses, and protects your data when you use our WhatsApp stock alert service."
                path="/privacy"
            />
            <Header />
            <Container
                width="min(calc(100% - 40px) , 900px)"
                justifyContent="center"
                margin="20px auto"
                column
                gap={"20px"}
            >
                <Typography
                    tag="h1"
                    fontFamily="Neue Montreal"
                    fontSize={"28px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    Privacy Policy
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    Last updated on <time dateTime="2025-03-22">Mar 22nd, 2025</time>
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    This privacy policy sets out how KONSRI TECHNOLOGIES PRIVATE LIMITED uses and protects any information that you give KONSRI TECHNOLOGIES PRIVATE LIMITED when you visit their website and/or agree to purchase from them.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    KONSRI TECHNOLOGIES PRIVATE LIMITED is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    KONSRI TECHNOLOGIES PRIVATE LIMITED may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you adhere to these changes.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    Information We May Collect includes name, contact information including email address, demographic information such as postcode, preferences and interests, and other information relevant to customer surveys and/or offers.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    If you believe that any information we are holding on you is incorrect or incomplete, please write to info@konsritech.com as soon as possible. We will promptly correct any information found to be incorrect.
                </Typography>
            </Container>
        </>
    );
};

export default Privacy;
